import React from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";

import FieldGroup from "../../FieldGroup/FieldGroup";

import mq from "../../../helpers/media-queries";

const Table = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding-top: ${rem(20)};
	font-family: sans-serif;
`;

const TableItem = styled.div`
	padding-top: ${rem(10)};
	padding-bottom: ${rem(10)};
	padding-right: ${rem(10)};
	padding-left: ${rem(14)};
	background: #f4f4f4;
	display: grid;
	grid-template-columns: 1fr 1fr;
	width: 100%;

	&:nth-of-type(even) {
		background-color: #fff;
	}

	${mq("sm", "min")} {
		width: 100%;
	}
`;

const TableItemTitle = styled.div`
	color: #5c5e62;
	font-size: ${rem(13)};
	line-height: 1.5;
`;

const TableItemText = styled.div`
	font-size: ${rem(13)};
	line-height: 1.5;
`;

const Specifications = ({ tableData }) => (
	<FieldGroup title={tableData.title}>
		<Table>
			{tableData.specs.map((item, index) => (
				<TableItem key={index}>
					<TableItemTitle>{item.title}</TableItemTitle>
					<TableItemText>{item.text}</TableItemText>
				</TableItem>
			))}
		</Table>
	</FieldGroup>
);

export default Specifications;
